<template>
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" :model="form" ref="form">
        <el-row>
          <el-col :span="6">
            <el-form-item>
              <el-input v-model="form.name" placeholder="请输入关键字"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm()">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;添加数字文物
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="thumbPicture" label="藏品图片" min-width="8%">
            <template slot-scope="scope">
              <viewer :options="{ url: 'data-maxUrl' }">
                <img class="g-pointer" :src="scope.row.collectImages &&scope.row.collectImages[0].attPath  || ''" :data-maxUrl="scope.row.collectImages &&scope.row.collectImages[0].attPath" alt :onerror="defaultImg" style="width: 36px;height: 36px">
              </viewer>
            </template>
          </el-table-column>
          <el-table-column label="藏品名称" min-width="20%" show-overflow-tooltip>
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="showDetail(scope.row.collectId)">{{scope.row.collectName}}</a>
            </template>
          </el-table-column>

          <el-table-column prop="signCode" label="总登记号" min-width="8%" show-overflow-tooltip>
          </el-table-column>

          <el-table-column prop="collectType" label="藏品分类" min-width="8%" show-overflow-tooltip>
          </el-table-column>

          <el-table-column prop="collectLevel" label="级别" min-width="8%" show-overflow-tooltip>
          </el-table-column>

          <el-table-column prop="typeCode" label="分类号" min-width="12%" show-overflow-tooltip>
          </el-table-column>

          <el-table-column prop="collectYear" label="年代" min-width="20%" show-overflow-tooltip>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="8%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="showDetail(scope.row.collectId)">详情</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <div>
      <el-dialog title="添加数字文物" :visible.sync="dialogVisible" :close-on-click-modal="false" :width="'80%'">
        <!-- 表头搜索 -->
        <cmpSearchDict ref="cmpSearchDict" :pageType="`6`" @getParams="getHeadParams"></cmpSearchDict>

        <div class="com-list-content" style="margin-top: 0;padding-top:0">
          <div class="button">
            <el-row>
              <el-button class="el-primary-border" round @click="saveCollection()">
                <svg-icon icon-class="add" />&nbsp;添加数字文物
              </el-button>
            </el-row>
          </div>
          <!-- 表格 -->
          <div class="table mt-20">
            <el-table stripe :data="tableData1" v-loading="listLoading1" @selection-change="handleSelectionChange" :row-key="(row)=>{ return row.collectId}">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="thumbPicture" label="藏品图片" min-width="8%">
                <template slot-scope="scope">
                  <viewer :options="{ url: 'data-maxUrl' }">
                    <img class="g-pointer" :src="scope.row.collectImages &&scope.row.collectImages[0].attPath  || ''" :data-maxUrl="scope.row.collectImages &&scope.row.collectImages[0].attPath" alt :onerror="defaultImg" style="width: 36px;height: 36px">
                  </viewer>
                </template>
              </el-table-column>
              <el-table-column prop="collectName" label="藏品名称" min-width="8%" show-overflow-tooltip>
              </el-table-column>

              <el-table-column prop="signCode" label="总登记号" min-width="8%" show-overflow-tooltip>
              </el-table-column>

              <el-table-column prop="collectType" label="藏品分类" min-width="8%" show-overflow-tooltip>
              </el-table-column>

              <el-table-column prop="collectLevel" label="级别" min-width="8%" show-overflow-tooltip>
              </el-table-column>

              <el-table-column prop="typeCode" label="分类号" min-width="8%" show-overflow-tooltip>
              </el-table-column>

              <el-table-column prop="collectYear" label="年代" min-width="20%" show-overflow-tooltip>
              </el-table-column>
            </el-table>

            <div class="pagination-container paging">
              <el-pagination :current-page="listQuery1.currentPage" :page-size="listQuery1.size" :total="total1" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange1" @current-change="handleCurrentChange1" />
            </div>
          </div>
        </div>
      </el-dialog>
    </div>

    <add-collect ref="addCollect"  @addCall="getData"></add-collect>

  </div>
</template>

<script>
import cmpSearchDict from '@cmp/collect/search-dict'
import dialogNameDetail from '@views/collect2/record/dialog-name-detail'
import addCollect from '@views/collect2/record/dialog-add-collect'
export default {
  components: {
    cmpSearchDict,
    addCollect

    // dialogNameDetail,
  },
  data() {
    return {
      defaultImg: this.$store.state.app.defaultImg,
      multipleSelection: [],
      form: {
        type: '',
        name: ''
      },
      listLoading: false,
      listLoading1: false,
      listQuery: { currentPage: 1, size: 10 },
      listQuery1: { currentPage: 1, size: 10 },
      headParams: {},
      total: 0,
      total1: 0,
      tableData: [],
      tableData1: [],
      multipleSelection: [],
      dialogVisible: false
    }
  },

  mounted() {
    this.getData()
  },
  
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.tableData = []
      this.$http.get('/bs/bsDigitalRelics/list',{
        ...this.form,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result && res.result.records) {
            res.result.records.map(item => {
              if (item.pictureIds) {
                item.thumbPicture = item.pictureIds
              }
            })
            this.tableData = res.result.records

            this.total = res.result.total
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // 重置查询
    resetForm() {
      this.form = {
        name: '',
        type: ''
      }
      this.listQuery.currentPage = 1
      this.getData()
    },


    // 获取头部参数
    getHeadParams(params) {
      this.listQuery.currentPage = 1
      this.headParams = params
      this.initCollectionList()
    },

    initCollectionList() {
      this.listLoading1 = true
      this.tableData1 = []
      this.$http.get('/collection/list', {
        ...this.listQuery1,
        ...this.headParams
      })
        .then(res => {
          this.listLoading1 = false
          if (res.success) {
            this.tableData1 = res.result
            this.total1 = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
    },

    handleSelectionChange(list) {
      let ids = []
      if (list && list.length > 0) {
        list.map(item => {
          ids.push(item.collectId)
        })
      }
      this.multipleSelection = ids;
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 新增
    handleAdd() {
      this.dialogVisible = true
      this.initCollectionList()
    },

    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$http.get('/bs/bsDigitalRelics/delete',{ digitalId: obj.digitalId }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 藏品名称
    showDetail(collectId) {
      this.$refs['addCollect'].init('detail', collectId)
    },

    // 关联展品
    saveCollection() {
      let self = this
      if (this.multipleSelection.length <= 0) {
        this.$message.warning('请选择')
        return
      }
      this.$http.get('/bs/bsDigitalRelics/save',{
        ids: this.multipleSelection.join(',')
      }).then(res => {
        if (res.success) {
          this.$message.success({
            message: "数字文物新增成功",
            duration: 500,
            onClose() {
              self.dialogVisible = false
              self.getData()
            }
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },


    // 表格分页
    handleSizeChange1(val) {
      this.listQuery1.size = val
      this.initCollectionList()
    },
    // 点击序号
    handleCurrentChange1(val) {
      this.listQuery1.currentPage = val
      this.initCollectionList()
    },

  },
}
</script>

<style lang="scss" scoped>
</style>